import { DEAL_TYPE_ID, TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const getHasAssociationsAndPriority = objectTypeId => [DEAL_TYPE_ID, TICKET_TYPE_ID].includes(objectTypeId);